import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { QualityOnboarding, UserOrg } from 'Interfaces/User/UserData';
import userInitialState from './state';
import {
    UserState,
    EmailNotificationSettingsUpdate,
} from './Interfaces/UserState';

const userSlice = createSlice({
    name: 'user',
    initialState: userInitialState,
    reducers: {
        SAVE: (state, action: PayloadAction<UserState>) => {
            return {
                ...state,
                ...action.payload,
            };
        },

        SAVE_USER_DATA: (state, action: PayloadAction<UserState>) => {
            const userData = action.payload;
            return {
                ...state,
                ...userData,
            };
        },
        CLEAN_USER_DATA: (state) => {
            return {
                ...state,
                userData: null,
                isAuth: false,
                userOrganizations: [],
            };
        },
        UPDATE_USER_NAME: (state, action: PayloadAction<string>) => {
            const newUserName = action.payload;
            return {
                ...state,
                userData: {
                    ...state.userData,
                    name: newUserName,
                },
            };
        },
        UPDATE_USER_SECONDARY_EMAIL: (state, action: PayloadAction<string>) => {
            const newUserSecondaryEmail = action.payload;
            return {
                ...state,
                userData: {
                    ...state.userData,
                    secondaryEmail: newUserSecondaryEmail,
                },
            };
        },
        UPDATE_USER_PHOTO_URL: (state, action: PayloadAction<string>) => {
            const newUserPhotoURL = action.payload;
            return {
                ...state,
                userData: {
                    ...state.userData,
                    photoURL: newUserPhotoURL,
                },
            };
        },
        UPDATE_USER_NOTIFICATION_SETTINGS: (
            state,
            action: PayloadAction<EmailNotificationSettingsUpdate>,
        ) => {
            const { notificationKey, notificationValue } = action.payload;
            return {
                ...state,
                userData: {
                    ...state.userData,
                    notificationSettings: {
                        ...state.userData.notificationSettings,
                        [notificationKey]: notificationValue,
                    },
                },
            };
        },
        UPDATE_USER_QUALITY_ONBOARDING: (
            state,
            action: PayloadAction<QualityOnboarding>,
        ) => {
            const qualityOnboarding = action.payload;
            return {
                ...state,
                userData: {
                    ...state.userData,
                    qualityOnboarding,
                },
            };
        },
        SET_USER_ORGANIZATIONS: (state, action: PayloadAction<UserOrg[]>) => {
            return {
                ...state,
                userOrganizations: action.payload,
            };
        },
    },
});

export const { reducer: userReducer, actions: userActions } = userSlice;
